import {useParams} from "react-router-dom"
import {useContext, useEffect} from "react"
import AuthContext from "../contexts/AuthContext.tsx"
import {Box, Typography} from "@mui/material"

const VerifyEmail = () => {
    const {token} = useParams()
    const {verifyEmailMutation, verifyMailError} = useContext(AuthContext)

    useEffect(() => {
        verifyEmailMutation.mutate(token)
    }, [token])

    return (
        verifyMailError &&
        <Box>
            <Typography variant="h4" gutterBottom display="center" alignItems="center">
                {verifyMailError}
            </Typography>
        </Box>
    )
}

export default VerifyEmail